import { PropsWithChildren } from 'lib-shared-types-utils';

import { createSearchUrlParams } from 'app/views/layout/views/search/utils';
import { AppLink } from 'components/appLink';

export type QueueLinkProps = {
  /** The id of the queue used to link to the conversations page */
  queueId: string;
} & PropsWithChildren;

export const QueueLink = ({
  queueId,
  children,
}: QueueLinkProps): JSX.Element => (
  <AppLink
    path="/search/conversations"
    params={createSearchUrlParams({
      filters: {
        strategy: 'all',
        filters: [
          {
            field: 'queue_id',
            operator: 'is_one',
            values: [{ value: queueId }],
          },
          {
            field: 'status',
            operator: 'is_one',
            values: [{ value: 'open' }, { value: 'pending' }],
          },
        ],
      },
    })}
  >
    {children}
  </AppLink>
);
